import styles from "./summary.module.css";
import ImgBuilder from "../../assets/ImgBuilder";
import { useLanguage } from '../../functions/setGetLanguage';
import Post from "../post/post";


const Summary = ({msg, idx, variables}) => {
  const { language } = useLanguage();

  const sum = (a) => a.reduce((x, y) => x + y, 0);
  const percentage = (item, sum) => sum ? (item / sum) * 100 : 0;

  const getProfile = (m) => {
    

    const allAsNormal = percentage(m[0][2] + m[1][2] + m[2][2], sum(m.flat()));
    const normalAsNormal = percentage(m[2][2], sum(m[2]));
    const emotionalAsEmotional = percentage(m[0][0], sum(m[0]));
    const conspAsConsp = percentage(m[1][1], sum(m[1]));
    const emotionalConspAsNormal = percentage(m[0][2] + m[1][2], sum(m[0]) + sum(m[1]));

    if (allAsNormal >= 80 && normalAsNormal >= 70 && emotionalConspAsNormal >= 50)
      return "GullibleSharer";
    if (allAsNormal >= 60 && allAsNormal < 80 && normalAsNormal >= 70 &&
        emotionalConspAsNormal >= 30 && emotionalConspAsNormal <= 50)
      return "CuriousBeliever";
    if (allAsNormal >= 40 && allAsNormal < 60 && normalAsNormal >= 60 &&
        normalAsNormal <= 75 && emotionalConspAsNormal >= 20 && emotionalConspAsNormal <= 40)
      return "CautiousExplorer";
    if (emotionalAsEmotional >= 70 && conspAsConsp >= 70 && normalAsNormal >= 70)
      return "SharpEyedAnalyst";

    return "MixedScanner";
  };



  const profileUser = getProfile(variables.confusion_matrix);
  const overalCorrect = (variables.confusion_matrix[0][0] + variables.confusion_matrix[1][1] + variables.confusion_matrix[2][2]);

  return (
    <div key={idx} className={styles.messageRow}>
      <div className={styles.summaryBox}>
        <div className={styles.imgContainer_summaryBox}>
          <img alt="" src={ImgBuilder.logo} className={styles.img_summaryBox}/>
        </div>
        <div className={styles.spaceBetween}>
          <p className={styles.topText}>{msg[`summary${language}`].header}</p>
          <p className={`${styles.topText} ${styles.purpleText}`}>{msg[`summary${language}`][profileUser].name}</p>
        </div>

        <div className={styles.statistics}>

          <div className={styles.leftStatistics}>
            
            <div className={styles.pieChart}>

              <div className={styles.pie}  style={{
                backgroundImage: `conic-gradient(transparent 0% ${100 - overalCorrect * 10}%, rgb(41, 148, 41, 0.6) ${100 - overalCorrect * 10}% 100%)`
              }}></div>

              <div className={styles.results}>
                <div className={styles.upperResults}>{overalCorrect}</div>
                <div className={styles.middleResults}></div>
                <div className={styles.lowerResults}>10</div>
              </div>
            </div>
            <div className={styles.textResults}> {msg[`summary${language}`].name} </div>

          </div>

          <img alt="sticker" src={ImgBuilder[`teenProfile${profileUser}`]} className={styles.imgStatistics}/>

          
          
        </div>

        <p className={styles.midText}>{msg[`summary${language}`].question1}</p>
         <div className={styles.aswerBrackets}>{msg[`summary${language}`][profileUser].answer_q1}</div>
        {/* <p className={styles.midText}>{msg[`summary${language}`][profileUser].short_explanation}</p>

        <div className={styles.aswerBrackets}>{msg[`summary${language}`][profileUser].description}</div> */}

        <p className={styles.midText}>{msg[`summary${language}`].question2[0]} <b>{variables.posts_posted}</b> {msg[`summary${language}`].question2[1]} </p>
        
        <Post message={msg[`summary${language}`][profileUser].answer_q2} isPlayerPost={false} additional_class={styles.playerPost}
        profilePic={ImgBuilder[`${variables.selected_profile}_small`]} profileName={variables.selected_profile}/>
        
      </div>
    </div>
  );
};
export default Summary;

